import PropTypes from "prop-types";
import { Box, Button, Paper, Typography } from "@mui/material";
import {
  ArrowForwardRounded,
  MenuBookOutlined,
  TuneRounded,
  HelpOutlineRounded,
} from "@mui/icons-material";
import ModuleGuideLibrary from "app/help/ModuleGuideLibrary";
import { panelSx } from "./welcomeStyles";
export default function WelcomeHelp({ hasModules }) {
  return (
    <Box
      component="aside"
      aria-label="Ayuda para empezar"
      sx={{ display: "grid", gap: 2, position: { lg: "sticky" }, top: 100 }}
    >
      <Paper sx={{ ...panelSx, p: 3 }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2,
            bgcolor: "action.hover",
            color: "info.main",
            display: "grid",
            placeItems: "center",
            mb: 2.5,
          }}
        >
          <MenuBookOutlined sx={{ fontSize: "25px !important" }} />
        </Box>
        <Typography
          component="h2"
          sx={{ color: "text.primary", fontWeight: 700, fontSize: 18, mb: 1 }}
        >
          ¿Primera vez por aquí?
        </Typography>
        <Typography sx={{ color: "text.secondary", fontSize: 12, lineHeight: 1.9 }}>
          {hasModules
            ? "Encuentra qué puedes hacer en cada módulo, cómo leer sus tablas y qué ocurre al guardar un cambio."
            : "Las guías estarán disponibles cuando tengas módulos habilitados. Consulta tus accesos con el administrador."}
        </Typography>
        <ModuleGuideLibrary
          renderTrigger={(open) => (
            <Button
              fullWidth
              onClick={open}
              endIcon={<ArrowForwardRounded />}
              sx={{
                "&&": {
                  bgcolor: "info.main",
                  color: "#fff",
                  mt: 2.5,
                  minHeight: 44,
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: 2,
                },
                "&&:hover": { filter: "brightness(.9)", bgcolor: "info.main" },
              }}
            >
              Consultar guías
            </Button>
          )}
        />
        {hasModules && (
          <Typography sx={{ color: "text.secondary", fontSize: 11, lineHeight: 1.7, mt: 1.5 }}>
            También puedes descargarlas en PDF.
          </Typography>
        )}
      </Paper>
      <Box sx={{ px: 2, py: 1.5, display: "flex", gap: 1.5, alignItems: "flex-start" }}>
        <TuneRounded sx={{ color: "text.secondary", fontSize: "19px !important", mt: 0.4 }} />
        <Box>
          <Typography sx={{ color: "text.primary", fontWeight: 600, fontSize: 12 }}>
            Un espacio cómodo para ti
          </Typography>
          <Typography sx={{ color: "text.secondary", fontSize: 11, mt: 0.5, lineHeight: 1.8 }}>
            En el engranaje de la barra superior puedes cambiar la apariencia y activar el modo
            noche.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ px: 2, display: "flex", gap: 1, alignItems: "center", color: "text.secondary" }}>
        <HelpOutlineRounded sx={{ fontSize: "15px !important" }} />
        <Typography sx={{ fontSize: 10 }}>Tus accesos dependen del rol de tu cuenta.</Typography>
      </Box>
    </Box>
  );
}
WelcomeHelp.propTypes = { hasModules: PropTypes.bool.isRequired };
